import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {
    all,
    biology,
    botany,
    chemistry,
    CorrectAnswer,
    economics,
    geography,
    history,
    mat,
    maths,
    physics,
    politicalScience,
    skipped,
    WrongAnswer,
    zoology,
} from 'assets'
import { FETCH_QUESTION_SET } from '../../constants/actionTypes'
import Palette from '../Palette/Palette'
import ProgressBar from '../ProgressBar/ProgressBar'
import './AnswerStatus.css'

const mapDispatchToProps = (dispatch) => ({
    onQuestionLoad: (payload) => dispatch({ type: FETCH_QUESTION_SET, payload }),
})

const AnswerStatus = (props) => {
    const { t, i18n } = useTranslation()
    const [correct, setCorrect] = useState(0)
    const [inCorrect, setInCorrect] = useState(0)
    const [left, setLeft] = useState(0)

    const handleStyle = (data) => {
        // if(props.qid == data.qid && data.question.isCurrentlyOpened){
        //     let el = document.getElementById(data.qid)
        //     if(el !== null && !isInViewport(el)){
        //         el.scrollIntoView(false)
        //     }
        // }
        if (data.question.isAnswered && !data.question.isMarkedForReview) {
            return 'isAnswered'
        }
        if (data.question.isMarkedForReview && !data.question.isAnswered) {
            return 'isMarkedForReview'
        }
        if (!data.question.isAnswered && data.question.isVisited) {
            return 'isVisited'
        }
        if (data.question.isAnswered && data.question.isMarkedForReview) {
            return 'isVisitedAndMarkedForReview'
        }
    }

    useEffect(() => {
        props.mockTestSubmit && answerStatusCount()
    }, [i18n.language])

    const answerStatusCount = () => {
        if (props.data.questionList.length > 0) {
            for (let i = 0; i < props.data.questionList.length; i++) {
                let right = 0,
                    wrong = 0
                props.data.questionList.map((data, i) => {
                    if (data.question.english_answer.choices) {
                        if (
                            data.question.questionType == 'MCMCQ' &&
                            data.question.isAnswered
                        ) {
                            let ans = []
                            data.question.english_answer.choices.map((item) => {
                                if (item.is_answer) ans.push(item.choiceId)
                            })
                            data.question.answerbyUser =
                                data.question.answerbyUser.filter(
                                    (item) => item != '',
                                )
                            if (
                                data.question.answerbyUser.sort().toString() ==
                                ans.sort().toString()
                            ) {
                                right++
                                return 'correctAnswer'
                            } else {
                                wrong++
                                return 'wrongAnswer'
                            }
                        } else {
                            for (
                                let i = 0;
                                i < data.question.english_answer.choices.length;
                                i++
                            ) {
                                if (
                                    data.question.english_answer.choices[i]
                                        .choiceId == data.question.answerbyUser ||
                                    data.question.answerbyUser.includes(
                                        data.question.english_answer.choices[i]
                                            .choiceId,
                                    )
                                ) {
                                    if (
                                        data.question.english_answer.choices[i]
                                            .is_answer
                                    ) {
                                        right++
                                        return 'correctAnswer'
                                    } else {
                                        wrong++
                                        return 'wrongAnswer'
                                    }
                                }
                            }
                        }
                    }
                    if (
                        data.question.isAnswered &&
                        !Array.isArray(data.question.english_answer.answer) &&
                        data.question.answerbyUser ==
                            data.question.english_answer.answer
                    ) {
                        right = right + 1
                        return 'correctAnswer'
                    }
                    if (
                        data.question.isAnswered &&
                        !Array.isArray(data.question.english_answer.answer) &&
                        data.question.answerbyUser !=
                            data.question.english_answer.answer
                    ) {
                        wrong = wrong + 1
                        return 'wrongAnswer'
                    }
                    if (
                        data.question.isAnswered &&
                        Array.isArray(data.question.english_answer.answer) &&
                        data.question.answerbyUser.sort().toString() ==
                            data.question.english_answer.answer.sort().toString()
                    ) {
                        right = right + 1
                        return 'correctAnswer'
                    }
                    if (
                        data.question.isAnswered &&
                        Array.isArray(data.question.english_answer.answer) &&
                        data.question.answerbyUser.sort().toString() !=
                            data.question.english_answer.answer.sort().toString()
                    ) {
                        wrong = wrong + 1
                        return 'wrongAnswer'
                    }
                })
                setCorrect(right)
                setInCorrect(wrong)
                const totalAttempted = right + wrong
                const totalLeft = props.data.questionList.length
                    ? props.data.questionList.length - totalAttempted
                    : 0
                setLeft(totalLeft)
            }
        }
    }

    const handleMockStyle = (data) => {
        if (
            data.question.isAnswered &&
            data.question.english_answer.choices != undefined
        ) {
            if (data.question.questionType == 'MCMCQ') {
                let ans = []
                data.question.english_answer.choices.map((item) => {
                    if (item.is_answer) ans.push(item.choiceId)
                })
                data.question.answerbyUser = data.question.answerbyUser.filter(
                    (item) => item != '',
                )
                if (
                    data.question.answerbyUser.sort().toString() ==
                    ans.sort().toString()
                ) {
                    return 'correctAnswer'
                } else {
                    return 'wrongAnswer'
                }
            } else {
                for (
                    let i = 0;
                    i < data.question.english_answer.choices.length;
                    i++
                ) {
                    if (
                        data.question.answerbyUser.includes(
                            data.question.english_answer.choices[i].choiceId,
                        )
                    ) {
                        if (data.question.english_answer.choices[i].is_answer)
                            return 'correctAnswer'
                        else return 'wrongAnswer'
                    }
                }
            }
        }
        if (
            data.question.isAnswered &&
            !Array.isArray(data.question.english_answer.answer) &&
            data.question.answerbyUser == data.question.english_answer.answer
        ) {
            return 'correctAnswer'
        }
        if (
            data.question.isAnswered &&
            !Array.isArray(data.question.english_answer.answer) &&
            data.question.answerbyUser != data.question.english_answer.answer
        ) {
            return 'wrongAnswer'
        }
        if (
            data.question.isAnswered &&
            Array.isArray(data.question.english_answer.answer) &&
            data.question.answerbyUser.sort().toString() ==
                data.question.english_answer.answer.sort().toString()
        ) {
            return 'correctAnswer'
        }
        if (
            data.question.isAnswered &&
            Array.isArray(data.question.english_answer.answer) &&
            data.question.answerbyUser.sort().toString() !=
                data.question.english_answer.answer.sort().toString()
        ) {
            return 'wrongAnswer'
        }
    }

    // hardcoded images so hardcoded names
    const handleSubject = (item, isIcon = false) => {
        return isIcon
            ? item.toLowerCase() === 'physics'
                ? physics
                : item.toLowerCase() === 'chemistry' ||
                  item.toLowerCase() === 'science'
                ? chemistry
                : item.toLowerCase() === 'mathematics'
                ? maths
                : item.toLowerCase() === 'biology'
                ? biology
                : item.toLowerCase() === 'geography'
                ? geography
                : item.toLowerCase() === 'history'
                ? history
                : item.toLowerCase() === 'mental ability'
                ? mat
                : item.toLowerCase() === 'political science'
                ? politicalScience
                : item.toLowerCase() === 'zoology'
                ? zoology
                : item.toLowerCase() === 'economics'
                ? economics
                : item.toLowerCase() === 'botany'
                ? botany
                : // adding all as defullt icon
                  all
            : item.toLowerCase() === 'physics'
            ? 'physics'
            : item.toLowerCase() === 'chemistry' || item.toLowerCase() === 'science'
            ? 'chemistry'
            : item.toLowerCase() === 'mathematics'
            ? 'maths'
            : item.toLowerCase() === 'biology'
            ? 'biology'
            : item.toLowerCase() === 'geography'
            ? 'geography'
            : item.toLowerCase() === 'history'
            ? 'history'
            : item.toLowerCase() === 'mental ability'
            ? 'mat'
            : item.toLowerCase() === 'political science'
            ? 'politicalScience'
            : item.toLowerCase() === 'zoology'
            ? 'zoology'
            : item.toLowerCase() === 'economics'
            ? 'economics'
            : item.toLowerCase() === 'botany'
            ? 'botany'
            : ''
    }
    return (
        <div className="answerstatus">
            {!props.mockTestSubmit ? (
                <div role="status" className="answerstatus-total">
                    {props.statusData.map((d, i) => {
                        return (
                            <Palette
                                key={i + 'palette'}
                                name={d.name}
                                className={d.className}
                                value={d.value}
                            />
                        )
                    })}
                </div>
            ) : null}
            {props.mockTestSubmit && (
                <div className="answer-count-row">
                    <div className="count-icon-text">
                        {correct}
                        <div style={{ display: 'flex' }}>
                            <img
                                style={{
                                    marginRight: '5px',
                                    height: '22px',
                                    width: '22px',
                                }}
                                src={CorrectAnswer}
                            />
                            <b style={{ fontSize: '14px' }}>{t('Correct')}</b>
                        </div>
                    </div>
                    <div className="count-icon-text">
                        {inCorrect}
                        <div style={{ display: 'flex' }}>
                            <img
                                style={{
                                    marginRight: '5px',
                                    height: '22px',
                                    width: '22px',
                                }}
                                src={WrongAnswer}
                            />
                            <b style={{ fontSize: '14px' }}>{t('Incorrect')}</b>
                        </div>
                    </div>
                    <div className="count-icon-text">
                        {left}
                        <div style={{ display: 'flex' }}>
                            <img
                                style={{
                                    marginRight: '5px',
                                    height: '22px',
                                    width: '22px',
                                }}
                                src={skipped}
                            />
                            <b style={{ fontSize: '14px' }}>{t('Not Attempted')}</b>
                        </div>
                    </div>
                </div>
            )}
            <div className={!props.mockTestSubmit ? 'answerstatus-current' : null}>
                <div className="subject-detail">
                    <img
                        className={`subject-icon ${handleSubject(
                            props.data.subject.en,
                        )}`}
                        src={handleSubject(props.data.subject.en, true)}
                    />
                    <span className="subject-name">
                        {props.data.subject[i18n.language]}
                    </span>
                </div>
                <div className="subject-progress">
                    <div
                        className={`progress-value ${handleSubject(
                            props.data.subject.en,
                        )}`}
                    >
                        <span>
                            {props.progressValue}%{' '}
                            {props.mockTestSubmit ? t('Attempted') : t('Completed')}
                        </span>
                    </div>
                    <ProgressBar
                        color={'lightgrey'}
                        ƒ
                        classes={handleSubject(props.data.subject.en)}
                        opacity={'1'}
                        barwidth={'100%'}
                        bgcolor={'#e6e9ea'}
                        barheight="2px"
                        done={props.progressValue}
                        style={{ backgroundColor: 'grey' }}
                    />
                </div>
                <div role="menu" className="attempted-questions">
                    {props.data.questionList.map((data, i) => {
                        return (
                            <div
                                className="button-container"
                                id={data.qid}
                                key={i + 'menu'}
                            >
                                <span
                                    role="menuitem"
                                    className={
                                        !props.mockTestSubmit
                                            ? handleStyle(data, false)
                                            : handleMockStyle(data, false)
                                    }
                                    style={
                                        data.question.isCurrentlyOpened === true
                                            ? {
                                                  width: '38px',
                                                  height: '38px',
                                                  'line-height': '38px',
                                                  margin: '6px',
                                              }
                                            : null
                                    }
                                    onClick={() => {
                                        props.handleSwitchQuestion(
                                            i - 1,
                                            props.data.questionList.length,
                                            data,
                                            true,
                                            'Navigation_Grid',
                                        )
                                    }}
                                >
                                    {data.qid}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default withRouter(connect(null, mapDispatchToProps)(AnswerStatus))
